/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  SitePublishingAuth,
  SitePublishingAuthUpdate,
} from "./data-contracts";

/**
 * @description Retrieves the authentication settings that protect a site's published content. Use this to review the current auth method before making changes or troubleshooting access issues.
 * @tags site-publishing-auth
 * @name GetSitePublishingAuthById
 * @summary Get the published content authentication configuration for a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/publishing/auth
 * @secure
 */

// @ts-ignore
export const getSitePublishingAuthById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SitePublishingAuth;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/publishing/auth",
  method: "get",
  streaming: false,
  tags: ["site-publishing-auth"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Modifies the authentication method used to protect a site's published content. Use this to enable, disable, or change the auth method for a published site.
 * @tags site-publishing-auth
 * @name UpdateSitePublishingAuthById
 * @summary Update the published content authentication configuration for a site
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/publishing/auth
 * @secure
 */

// @ts-ignore
export const updateSitePublishingAuthById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: SitePublishingAuthUpdate;
  RequestHeaders: {};
  ResponseBody: SitePublishingAuth;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/publishing/auth",
  method: "patch",
  streaming: false,
  tags: ["site-publishing-auth"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Re-generates the private key used for the site's publishing authentication (e.g., JWT signing key for SSO). Existing tokens signed with the old key will become invalid immediately. Use this to rotate credentials after a security incident or as part of a regular key rotation policy.
 * @tags site-publishing-auth
 * @name RegenerateSitePublishingAuthById
 * @summary Regenerate the private key for a site's published content authentication
 * @request POST:/orgs/{organizationId}/sites/{siteId}/publishing/auth/regenerate
 * @secure
 */

// @ts-ignore
export const regenerateSitePublishingAuthById: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SitePublishingAuth;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/publishing/auth/regenerate",
  method: "post",
  streaming: false,
  tags: ["site-publishing-auth"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
